<app-table
  (changesSaved)="changesSaved($event)"
  [actionColumnWidth]="150"
  [columns]="columns"
  [editable]="isManager"
  [style]="{ height: '100%' }"></app-table>
